import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './index.vdt';
import { sizes } from '../../styles/utils';
import { useStep } from './useStep';
import { useFormatter } from './useFormatter';
import { useValue } from './useValue';
import { useChange } from './useChange';
import { useConfigContext } from '../config';
var typeDefs = {
  value: Number,
  disabled: Boolean,
  max: Number,
  min: Number,
  step: [Number, Object, Function],
  size: sizes,
  vertical: Boolean,
  precision: Number,
  formatter: Function,
  parser: Function,
  prefix: String,
  suffix: String,
  width: [String, Number],
  forceStep: Boolean
};
var defaultStep = 1;
var defaults = function defaults() {
  return {
    value: 0,
    max: Number.POSITIVE_INFINITY,
    min: Number.NEGATIVE_INFINITY,
    step: defaultStep,
    size: 'default'
  };
};
var events = {
  change: true
};
export var Spinner = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Spinner, _Component);
  function Spinner() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.step = useStep(defaultStep);
    _this.formatter = useFormatter();
    _this.value = useValue(_this.step, _this.formatter);
    _this.change = useChange(_this.step, _this.value.fixValue);
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Spinner.prototype;
  _proto.isDisabledDecrease = function isDisabledDecrease() {
    var _this$get = this.get(),
      value = _this$get.value,
      min = _this$get.min,
      disabled = _this$get.disabled;
    return disabled || value <= min;
  };
  _proto.isDisabledIncrease = function isDisabledIncrease() {
    var _this$get2 = this.get(),
      value = _this$get2.value,
      max = _this$get2.max,
      disabled = _this$get2.disabled;
    return disabled || value >= max;
  };
  return Spinner;
}(Component);
Spinner.template = template;
Spinner.typeDefs = typeDefs;
Spinner.defaults = defaults;
Spinner.events = events;